import { TabsList, TabsTrigger } from "@/components/ui/tabs";

const TabsNavigation = () => {
  return (
    <div className="mb-6 min-w-0 overflow-x-hidden">
      <TabsList className="inline-flex h-auto min-w-full w-max gap-1 p-1 md:grid md:w-full md:min-w-0 md:grid-cols-8">
        <TabsTrigger value="overview" className="min-w-0 whitespace-normal text-right">סקירה כללית</TabsTrigger>
        <TabsTrigger value="offices" className="min-w-0 whitespace-normal text-right">משרדים</TabsTrigger>
        <TabsTrigger value="users" className="min-w-0 whitespace-normal text-right">משתמשים</TabsTrigger>
        <TabsTrigger value="accounts" className="min-w-0 whitespace-normal text-right">חשבונות</TabsTrigger>
        <TabsTrigger value="plans" className="min-w-0 whitespace-normal text-right">תוכניות מנוי</TabsTrigger>
        <TabsTrigger value="apps" className="min-w-0 whitespace-normal text-right">אפליקציות</TabsTrigger>
        <TabsTrigger value="usage" className="min-w-0 whitespace-normal text-right">שימוש AI</TabsTrigger>
        <TabsTrigger value="mcp-usage" className="min-w-0 whitespace-normal text-right">שימוש MCP</TabsTrigger>
      </TabsList>
    </div>
  );
};

export default TabsNavigation;
